import { useEffect, useState } from "react";
import SpinnerLoader from "../../../../components/loader/spinner-loader";
import InputField from "../../../../components/form/input-field";
import SelectField from "../../../../components/form/select-field";
import ApiSupport from "../../../../lib/api-support";
import { ErrorFlash, SuccessFlash } from "../../../../components/helper/flash-notification";

const SendNotification = ({ channels } : {channels?: any}) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [title, setTitle] = useState<string>('');
    const [titleError, setTitleError] = useState<string | null>(null);

    const [message, setMessage] = useState<string>('');
    const [messageError, setMessageError] = useState<string | null>(null);

    const [channel, setChannel] = useState<string>('all');
    const [channelError, setChannelError] = useState<string | null>(null);

    const [channelsOptions, setChannelsOptions] = useState<any>([{ name: 'All users', value: 'all' },]);

    useEffect(() => {
        channels.map((channel: any) => {
            setChannelsOptions((prev: any) => [...prev, { name: channel.name, value: channel.uuid }])
        })
    }, [channels])

    const options = [
        { name: 'All users', value: 'all' },
    ];

    const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!title) {
            setTitleError('Title is required');
            return;
        }
        if (!message) {
            setMessageError('Message is required');
            return;
        }
        setLoading(true);

        const request = await new ApiSupport().post(`pushNotification/send`, {
            title,
            body:message,
            channel
        });
        setLoading(false);
        if (request === 'error') {
            ErrorFlash('Error processing request, try again.');
            return;
        }
        setTitle('');
        setMessage('');
        SuccessFlash('Notification sent successfully.');
        setShowModal(false);
    }

    return (
        <div className="relative">
            <button onClick={() => setShowModal(true)} className="flex items-center space-x-2 border rounded-md text-blue-black border-primary-light hover:bg-opacity-90 input w-fit">
                <span>Send Notification</span>
            </button>
            {(
                <div>
                    <div className={`${showModal ? 'flex' : 'hidden'} overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full`}>
                        <div className="relative w-full max-w-lg max-h-full p-4">
                            <div className="relative bg-white rounded-lg shadow">
                                <form onSubmit={submitForm} className="p-4 text-center md:p-5">
                                    <h3 className="my-5 mb-5 text-lg font-normal text-tertiary">
                                        Send Notification
                                    </h3>
                                    <div className="grid gap-4 mb-5 text-left">
                                        <InputField
                                            label="Title"
                                            onChangeInput={(e) => [setTitle(e.target.value), setTitleError(null)]}
                                            error={titleError}
                                            placeholder="Enter notification title"
                                            value={title}
                                        />
                                        <InputField
                                            label="Message"
                                            onChangeInput={(e) => [setMessage(e.target.value), setMessageError(null)]}
                                            error={messageError}
                                            placeholder="Enter notification message"
                                            value={message}
                                        />
                                        <SelectField
                                            label="Topic"
                                            options={channelsOptions}
                                            onChangeInput={value => [setChannel(value), setChannelError(null)]}
                                            error={channelError}
                                            value={channel}
                                            placeholder="Select topic"
                                        />
                                    </div>
                                    <button disabled={loading} type="submit" className="text-white space-x-2 bg-primary hover:bg-tertiary focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center">
                                        <span>Send notification</span>
                                        {loading && <SpinnerLoader />}
                                    </button>
                                    <button disabled={loading} onClick={() => setShowModal(!showModal)} type="button" className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 ">
                                        Cancel
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className={`fixed inset-0 z-40 bg-gray-900/50 ${showModal ? '' : 'hidden'}`}></div>
                </div>
            )}
        </div>
    );
}

export default SendNotification;